<template>
    <div>
        <div v-if="!addSubToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Sub Category" @click="addSubToggle = !addSubToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add') + $t('header.subCategory', {'item': $t('subMenu.salon_menu_discount')})}}</span>
            </button>
        </div>
        <div v-if="addSubToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add') + $t('header.subCategory', {'item': $t('subMenu.salon_menu_discount')})}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <discountSubForm :isEdit="false" :category="category" @returnDiscountSubList="closeModal" @submitForm="addSubCategory"></discountSubForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!addSubToggle" class="px-3 px-sm-5 py-3">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 align-items-center justify-content-start">
                            <div class="dataTables_filter mb-2">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchSubCategory" @keypress.enter="searchSubCategoryItem">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchSubCategoryItem">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox mb-3">
                                <input type="checkbox" class="custom-control-input" id="showSubEnabled" @change="filterEnable($event)" v-model="isEnable">
                                <label class="custom-control-label" for="showSubEnabled">{{$t('label.show_enable')}}</label>
                            </div>
                            <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                        </div>
                    </div>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterByCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <subCategory :items="subCategory" :startPage="startPage" :category="category" @showEditSubCategory="showEditSubCategory"></subCategory>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t('header.subCategory', {'item': $t('subMenu.salon_menu_discount')})}}
                            <small class="m-0 text-muted">{{$t('header.subCategory', {'item': $t('subMenu.salon_menu_discount')})}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <discountSubForm ref="editDiscountSubForm" :isEdit="true" :category="category"  @submitForm="editSubCategory" @deleteSubCategory="deleteSubCategory"></discountSubForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import SubCategory from './../Salon_Menu_Sub_Category'
import DiscountSubForm from './Discount_SubForm'
import {setReturnData, handleSessionExpired, getCategoryText, setCategoryLabel, setSalonMenuSubCategoryExportFields}
from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'discountSubCategoryList',
    components:{
        DiscountSubForm, SubCategory
    },
    data(){
        return{
            type: 'discount',
            isEnable: true,
            isSpinnerShow: false,
            searchSubCategory: "", selectedTab: "all",
            subCategory: [], category: [],
            addSubToggle: false, editToggleModal: false,
            sTitle: "", sCategory: 0,
            page: 0, totalEntries: 0, totalPage: 0, startPage: 0, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "",
            discountExportData: []      
        }
    },
    computed:{
        exportFields(){
            return setSalonMenuSubCategoryExportFields(this)
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setLabel()
            this.setExportData(this.discountExportData)
        }
    },
    methods:{
        getCategoryText(id, arr){
            return getCategoryText(id, arr)
        },
        closeModal(isError){
            if(!isError){
                this.addSubToggle = false;
                this.filterSubCategoryItem(this.selectedTab, this.isEnable);
            }
            this.$parent.$parent.isModalShow = false;
        },
        clearFilter(){
            this.searchSubCategory = "";
            this.isEnable = true;
            this.getDiscountSubCategory("");
        },
        searchSubCategoryItem(){
            var strFilter = this.searchSubCategory == "" ? "" : "&search=" + this.searchSubCategory;
            this.selectedTab = "all";
            this.getDiscountSubCategory(strFilter);
        },
        filterByCategory(item){
            this.selectedTab = item;
            this.filterSubCategoryItem(this.selectedTab, this.isEnable);
        },
        filterEnable(e){
            this.isEnable = e.target.checked ? true : false;
            this.filterSubCategoryItem(this.selectedTab, this.isEnable);
        },
        filterSubCategoryItem(category, isEnable){
            var strFilterCategory = category == "all" ? "" : "&category=" + category;
            var strFilterIsEnable = isEnable ? "&isEnable=1" : "&isEnable=0";
            var strFilter = strFilterCategory + strFilterIsEnable;
            this.getDiscountSubCategory(strFilter);
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterSubCategoryItem(this.selectedTab, this.isEnable);
            }
        },
        async getExportData(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + strFilter
            const url =  this.$api.MENU_FOLDER + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.folder
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.discountExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            this.exportData = []

            let header = this.$msg.REPORT.HEADER + this.$i18n.t('header.subCategory', {'item': this.$i18n.t('subMenu.salon_menu_discount')})
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    folderID: data[i].folderID,
                    title: data[i].title,
                    category: getCategoryText(data[i].category, this.category),
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable')
                })
            }
        },
        async getDiscountSubCategory(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + "&page=" + this.page + strFilter
            const url =  this.$api.MENU_FOLDER + QUERY_STRING;

            this.isSpinnerShow = true
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var retData = setReturnData(response.data.folder, response.data.count, $vm.page)
                $vm.subCategory = retData.result;
                $vm.totalEntries = retData.count;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(strFilter)
        },
        addSubCategory(data){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.MENU_FOLDER,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data.folder[0];
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        showEditSubCategory(item){
            this.sID = item.folderID
            this.sTitle = item.title;
            this.editToggleModal = true;
            this.$refs.editDiscountSubForm.editDiscountSubForm(item)
        },
        editSubCategory(data){
            let QUERY_STRING = "/" + this.sID + this.$api.UPDATE
            const url =  this.$api.MENU_FOLDER + QUERY_STRING;
                
            let $vm = this
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.editToggleModal = false;
                    var retData = response.data.folder[0];
                    var message =  "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        deleteSubCategory(id, title){
            let $vm = this;
            this.sTitle = title;
            this.deleteToggleModal = true;

            document.getElementById('btnSubDeleteYes').onclick = function(){
                let QUERY_STRING = "/" + id + "/delete"
                const url =  this.$api.MENU_FOLDER + QUERY_STRING;

                this.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: this.$axios.defaults.baseURL, 
                    headers: {token: this.$util.getSessionToken()},
                })
                .then((response) => {
                    if(response.status == 200){
                        $vm.deleteToggleModal = false;
                        var message = "Discount Sub-Category deleted successfully."
                        $vm.$parent.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if(error == "Invalid Token"){
                        handleSessionExpired();   
                    }
                })
            }
        },
        setLabel(){
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.discount)
        },
    },
    mounted(){
        let $vm = this;
        $vm.setLabel()
        $vm.getDiscountSubCategory("");
    }
}
</script>
<style scoped>
.nav-link, .link{
    cursor: pointer;
}
.link > i {
    font-size: large;
}
.show{
    display: block;
}
</style>